import type { AccountSettings } from "./accounts";

export type PacingPreset = {
    id: string;
    label: string;
    /** Mô tả nhịp cho người dùng hình dung, không phải thuật ngữ kỹ thuật */
    hint: string;
    tone: "safe" | "normal" | "fast" | "turbo";
    settings: Pick<AccountSettings, "minDelayMs" | "maxDelayMs" | "maxPerHour" | "maxPerDay">;
};

/**
 * Nhịp do HAI Ô NGHỈ quyết định; trần giờ chỉ là chặn trên. Nên mỗi preset đặt
 * khoảng nghỉ ra đúng tốc độ nó hứa, rồi đặt trần giờ **vừa khớp** với tốc độ
 * đó (`3600 / nhịp`).
 *
 * Đặt trần thấp hơn nhịp là sinh ra kiểu chạy "bắn một tràng rồi đứng im tới
 * đầu giờ sau" — nhìn máy móc hơn hẳn gửi đều tay, đúng thứ đang cố tránh.
 */
export const PACING_PRESETS: PacingPreset[] = [
    {
        id: "safe",
        label: "Chậm",
        hint: "1 tin mỗi 2 phút",
        tone: "safe",
        settings: { minDelayMs: 100_000, maxDelayMs: 140_000, maxPerHour: 30, maxPerDay: 400 },
    },
    {
        id: "normal",
        label: "Vừa",
        hint: "1 tin mỗi 30 giây",
        tone: "normal",
        settings: { minDelayMs: 25_000, maxDelayMs: 35_000, maxPerHour: 120, maxPerDay: 1_500 },
    },
    {
        id: "fast",
        label: "Nhanh",
        hint: "1 tin mỗi 9 giây",
        tone: "fast",
        settings: { minDelayMs: 7_000, maxDelayMs: 11_000, maxPerHour: 400, maxPerDay: 5_000 },
    },
    {
        id: "turbo",
        label: "Rất nhanh",
        hint: "1 tin mỗi 2 giây",
        tone: "turbo",
        settings: { minDelayMs: 1_000, maxDelayMs: 3_000, maxPerHour: 1_800, maxPerDay: 15_000 },
    },
];

export function matchPreset(settings: AccountSettings): PacingPreset | undefined {
    return PACING_PRESETS.find((preset) =>
        (Object.keys(preset.settings) as (keyof typeof preset.settings)[]).every(
            (key) => preset.settings[key] === settings[key],
        ),
    );
}
